import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import "../../assets/css/Footer.css";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const agencies = [
  { name: "Federal Housing Authority", url: "https://fha.gov.ng" },
  { name: "Federal Mortgage Bank of Nigeria", url: "https://www.fmbn.gov.ng" },
  {
    name: "Surveyors Registration Council of Nigeria",
    url: "https://surcon.gov.ng",
  },
  {
    name: "Office of the Surveyor General of the Federation",
    url: "http://osgof.gov.ng",
  },
  {
    name: "Architects Registration Council of Nigeria",
    url: "https://www.arconigeria.gov.ng",
  },
  {
    name: "Council of Registered Builders of Nigeria",
    url: "https://www.corbon.gov.ng/",
  },
  {
    name: "Quantity Surveyors Registration Board of Nigeria",
    url: "https://qsrbn.gov.ng",
  },
  {
    name: "Town Planners Registration Council of Nigeria",
    url: "https://toprecng.org",
  },
  {
    name: "Nigerian Institution of Estate Surveyors and Valuers",
    url: "https://www.niesv.org.ng",
  },
  {
    name: "Estate Surveyors and Valuers Registration Board of Nigeria",
    url: "https://www.esvarbon.gov.ng",
  },
];

const usefulLinks = [
  {
    name: "Legal Disclaimer & Privacy Policy",
    url: "/Legal Disclaimer and Privacy Policy/15",
  },
  { name: "Frequently Asked Questions", url: "/F.A.Q/38" },
  { name: "Disclaimer", url: "/Disclaimer/18" },
  {
    name: "Staff Webmail",
    url: "https://webmail.fmhud.gov.ng",
    external: true,
  },
];

const socialLinks = [
  {
    name: "X (Twitter)",
    url: "https://twitter.com/FMHUD_NG",
    icon: "fa-x-twitter",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/FMHUDNG",
    icon: "fa-facebook-f",
  },
  {
    name: "LinkedIn",
    url: "https://www.linkedin.com/in/FMHUDNG",
    icon: "fa-linkedin-in",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/fmhudng",
    icon: "fa-instagram",
  },
  {
    name: "YouTube",
    url: "https://www.youtube.com/channel/UC3P5Hj-gEdcf-cNJS8pAQ2g",
    icon: "fa-youtube",
  },
];

const newsCategories = [
  {
    name: "Latest Press",
    url: "/read/title_show_echo_01zz",
    key: "latest_news",
  },
  {
    name: "Public Announcements",
    url: "/read/title_show_echo_01",
    key: "public_announcement",
  },
  { name: "Other News", url: "/read/title_show_echo_02", key: "other_news" },
  { name: "Speeches", url: "/read/title_show_echo_03", key: "speeches" },
];

function Footer() {
  const navigate = useNavigate();
  const [allSection, setAllSection] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}footer-counts`);
        setAllSection(response.data || {});
      } catch (error) {
        console.error("Unable to load footer counts:", error);
      }
    };

    fetchData();
  }, []);

  const handleSearch = (event) => {
    event.preventDefault();

    const query = searchTerm.trim();

    if (query) {
      navigate(`/searches/${encodeURIComponent(query)}`);
    }
  };

  return (
    <footer className="fmhud-footer">
      {/* ARCHIVE SEARCH */}
      <section className="fmhud-footer-search">
        <div className="container">
          <div className="fmhud-search-panel">
            <div className="fmhud-search-copy">
              <span className="fmhud-eyebrow">EXPLORE OUR ARCHIVES</span>
              <h2>Looking for something?</h2>
              <p>
                Search ministry news, public announcements, speeches and
                published documents.
              </p>
            </div>

            <form className="fmhud-search-form" onSubmit={handleSearch}>
              <label className="visually-hidden" htmlFor="fmhud-archive-search">
                Search the ministry archive
              </label>
              <input
                id="fmhud-archive-search"
                type="search"
                value={searchTerm}
                onChange={(event) => setSearchTerm(event.target.value)}
                placeholder="Enter a keyword..."
                required
              />
              <button type="submit">
                <i
                  className="fa-solid fa-magnifying-glass"
                  aria-hidden="true"
                />
                <span>Search</span>
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* MAIN FOOTER */}
      <div className="fmhud-footer-main">
        <div className="container">
          <div className="row gy-5">
            {/* MINISTRY CONTACT */}
            <div className="col-lg-4 col-md-6">
              <div className="fmhud-footer-brand">
                <span className="fmhud-brand-mark" aria-hidden="true">
                  <i className="fa-solid fa-landmark" />
                </span>
                <div>
                  <h3>FEDERAL MINISTRY OF HOUSING AND URBAN DEVELOPMENT</h3>
                  <p>FEDERAL REPUBLIC OF NIGERIA</p>
                </div>
              </div>

              <p className="fmhud-footer-intro">
                Building a better Nigeria through affordable housing,
                sustainable urban development and improved living standards.
              </p>

              <h4 className="fmhud-footer-heading">Contact the Ministry</h4>

              <ul className="fmhud-contact-list">
                <li>
                  <i className="fa-solid fa-location-dot" aria-hidden="true" />
                  <span>
                    <strong>Headquarters</strong>
                    <br />
                    Federal Ministry of Housing and Urban Development, Mabushi,
                    Abuja
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-envelope" aria-hidden="true" />
                  <span>
                    <a href="mailto:info@fmhud.gov.ng">info@fmhud.gov.ng</a>
                    <br />
                    <a href="mailto:hmregistry@fmhud.gov.ng">
                      hmregistry@fmhud.gov.ng
                    </a>
                    <br />
                    <a href="mailto:hmsregistry@fmhud.gov.ng">
                      hmsregistry@fmhud.gov.ng
                    </a>
                    <br />
                    <a href="mailto:psregistry@fmhud.gov.ng">
                      psregistry@fmhud.gov.ng
                    </a>
                  </span>
                </li>
                <li>
                  <i className="fa-solid fa-phone" aria-hidden="true" />
                  <span>
                    <strong>Telephone</strong>
                    <br />
                    <a href="tel:+2348061743313">+234 806 174 3313</a>
                    <small>Monday–Friday, 8:00 am–4:00 pm</small>
                  </span>
                </li>
              </ul>

              <h4 className="fmhud-footer-heading">Follow Us</h4>
              <div className="fmhud-footer-socials">
                {socialLinks.map((social) => (
                  <a
                    key={social.name}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Visit FMHUD on ${social.name}`}
                    title={social.name}
                  >
                    <i
                      className={`fa-brands ${social.icon}`}
                      aria-hidden="true"
                    />
                  </a>
                ))}
              </div>
            </div>

            {/* AGENCIES */}
            <div className="col-lg-3 col-md-6">
              <h4 className="fmhud-footer-heading">Related Agencies</h4>
              <p className="fmhud-footer-muted">
                Public institutions and professional bodies.
              </p>

              <ul className="fmhud-footer-links">
                {agencies.map((agency) => (
                  <li key={agency.name}>
                    <a
                      href={agency.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i
                        className="fa-solid fa-arrow-up-right-from-square"
                        aria-hidden="true"
                      />
                      {agency.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* NEWS AND USEFUL LINKS */}
            <div className="col-lg-2 col-md-6">
              <h4 className="fmhud-footer-heading">News & Updates</h4>
              <p className="fmhud-footer-muted">
                Explore ministry publications.
              </p>

              <ul className="fmhud-footer-links fmhud-category-links">
                {newsCategories.map((category) => (
                  <li key={category.key}>
                    <Link to={category.url}>
                      <span>{category.name}</span>
                      <span className="fmhud-count">
                        {allSection[category.key] ?? 0}
                      </span>
                    </Link>
                  </li>
                ))}
              </ul>

              <h4 className="fmhud-footer-heading fmhud-useful-heading">
                Useful Links
              </h4>
              <ul className="fmhud-footer-links">
                {usefulLinks.map((item) => (
                  <li key={item.name}>
                    {item.external ? (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i
                          className="fa-solid fa-arrow-up-right-from-square"
                          aria-hidden="true"
                        />
                        {item.name}
                      </a>
                    ) : (
                      <Link to={item.url}>
                        <i
                          className="fa-solid fa-angle-right"
                          aria-hidden="true"
                        />
                        {item.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            {/* LOCATION */}
            <div className="col-lg-3 col-md-6">
              <h4 className="fmhud-footer-heading">Find Us</h4>
              <p className="fmhud-footer-muted">
                Visit our headquarters in Abuja, Nigeria.
              </p>

              <div className="fmhud-map-frame">
                <iframe
                  title="Federal Ministry of Housing and Urban Development location map"
                  src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3939.8214274164316!2d7.453387!3d9.080027!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x104e0b0051bb9dff%3A0xb06406a0d062ec36!2sFederal%20Ministry%20of%20Housing%20and%20Urban%20Development!5e0!3m2!1sen!2sng!4v1777032230675!5m2!1sen!2sng"
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  allowFullScreen
                />
              </div>

              <a
                className="fmhud-directions-link"
                href="https://www.google.com/maps/search/?api=1&query=Federal+Ministry+of+Housing+Urban+Development+Mabushi+Abuja"
                target="_blank"
                rel="noopener noreferrer"
              >
                Get directions
                <i
                  className="fa-solid fa-arrow-up-right-from-square"
                  aria-hidden="true"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* COPYRIGHT BAR */}
      <div className="fmhud-footer-bottom">
        <div className="container">
          <div className="fmhud-bottom-inner">
            <p>
              © {new Date().getFullYear()}{" "}
              <strong>Federal Ministry of Housing and Urban Development</strong>
              . All rights reserved.
            </p>
            <p className="fmhud-designed-by">
              Designed by :{" "}
              <a
                href="https://cviewsoft.com.ng"
                target="_blank"
                rel="noopener noreferrer"
              >
                CViewSoft Ltd
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
